import { Context, createContext } from 'react';

import { PageData } from '../../interfaces';

export const PageDataContext: Context<PageData | null> = createContext<PageData | null>(null);
